import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import DefaultButton from '../../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerPhoneNumberInput from '../../../inputs/customerPhoneInput/CustomerPhoneNumberInput';
import CustomerPasswordInput from '../../../inputs/customerPasswordInput/CustomerPasswordInput';
import CustomerVerificationInput from '../../../inputs/customerVerificationInput/CustomerVerificationInput';
import CustomerCheckInput from '../../../inputs/customerCheckInput/CustomerCheckInput';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function LegalRegistrationSecondStepForm({
  form, handleSubmit, formValues, errors, setErrors,
}) {
  const { setShowTermsModal } = useModal();
  const { trans, configInfo } = useTranslation();

  const isGeorgian = configInfo?.countryCode === 'GE';

  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit}>
      <div className="flex flex-col lg:flex-row lg:gap-4">
        <CustomerPhoneNumberInput
          options={formValues?.countries?.map((country) => ({
            label: country.country_phone_code,
            value: country.id,
          }))}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className={`${isGeorgian ? 'basis-1/2' : 'basis-full'} white-background`}
          name="phone_number"
          label={trans('phone_number')}
          selectName="country_phone_code"
          required
          codeSelectDisabled
          errorMessage={errors?.country_phone_code || errors?.phone_number}
        />
        {isGeorgian && (
        <CustomerVerificationInput
          className="basis-1/2 -mt-8 lg:mt-0"
          name="verified_phone"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
          verifyType={2}
        />
        )}
      </div>
      <div className="flex flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="basis-1/2"
          name="email"
          label={trans('email')}
          required
          errorMessage={errors?.email}
        />
        <CustomerVerificationInput
          className="basis-1/2 -mt-8 lg:mt-0"
          name="verified_email"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
          verifyType={1}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerPasswordInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }, {
            min: 8,
            message: trans('password_min_8_length'),
          }]}
          className="basis-1/2"
          name="password"
          label={trans('password')}
          required
          errorMessage={errors?.password && trans(errors?.password)}
        />
        <CustomerPasswordInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(trans('passwords_do_not_match'));
            },
          }),
          ]}
          className="basis-1/2"
          name="repeat_password"
          label={trans('repeat_password')}
          required
          errorMessage={errors?.repeat_password}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4 lg:pt-[25px]">
        <div className="flex flex-col basis-1/2 relative">
          <CustomerCheckInput
            className="lg:absolute -top-5"
            label={(
              <button
                type="button"
                className="text-primary border-0 bg-transparent cursor-pointer text-[12px]"
                onClick={() => {
                  setShowTermsModal('terms-conditions');
                }}
              >
                {trans('agree_to_terms')}
              </button>
            )}
            name="agree_to_service_conditions"
            errorMessage={errors?.agree_to_service_conditions}
          />
          <CustomerCheckInput
            className="lg:absolute top-5"
            label={(
              <button
                type="button"
                className="text-primary border-0 bg-transparent cursor-pointer text-[12px]"
                onClick={() => {
                  setShowTermsModal('confidentiality-policy');
                }}
              >
                {trans('agree_to_confidentiality')}
              </button>
            )}
            name="agree_to_confidentiality"
            errorMessage={errors?.agree_to_confidentiality}
          />
        </div>
        <DefaultButton
          type="submit"
          className="basis-1/2 text-base leading-[22px] h-[60px] mt-auto mb-6"
        >
          {trans('finish_registration')}
        </DefaultButton>
      </div>
    </Form>
  );
}
export default LegalRegistrationSecondStepForm;
